import { useNavigate } from "react-router-dom";
import { Confirmation, Reason } from "../../Components/Modal";
import Table from "../../Components/Table";
import StatusHandler from "../../Components/Table/StatusHandler";
import useTableControls from "../../Hooks/useTableControls";
import useFetchData from "../../Hooks/useFetchData";
import { getSignupRequests } from "../../Services/SignupRequest";
import { format_date, getSerialNumber } from "../../Utils/helpers";
import BackButton from "../../Components/BackButton";
import "../Dashboard/Dashboard.css";

export default function SignupRequests() {
    const navigate = useNavigate();

    // const sampleData = [
    //   {
    //     sn: "1",
    //     name: "Mark Carson",
    //     email: "abc@xyz.com",
    //     date: "01/02/2022",
    //     phone: "+1 12 213 0",
    //     requestApprovalStatus: "pending",
    //   },
    //   {
    //     sn: "2",
    //     name: "Mark Carson",
    //     email: "abc@xyz.com",
    //     date: "01/02/2022",
    //     phone: "+1 12 213 0",
    //     requestApprovalStatus: "accepted",
    //   },
    //   {
    //     sn: "3",
    //     name: "Mark Carson",
    //     email: "abc@xyz.com",
    //     date: "01/02/2022",
    //     phone: "+1 12 213 0",
    //     requestApprovalStatus: "pending",
    //   },
    //   {
    //     sn: "4",
    //     name: "Mark Carson",
    //     email: "abc@xyz.com",
    //     date: "01/02/2022",
    //     phone: "+1 12 213 0",
    //     requestApprovalStatus: "pending",
    //   },
    // ];

    const {
        perPage,
        setPerPage,
        status,
        setStatus,
        search_string,
        setSearchString,
        from,
        setFrom,
        to,
        setTo,
    } = useTableControls();

    const {
        // INTERNAL EXPORTS
        page,
        setPage,
        // REACT QUERY EXPORTS
        isFetching,
        isLoading,
        data,
        refetch,
    } = useFetchData("signupRequest_logs", getSignupRequests, [
        perPage,
        search_string,
        "pending",
        from,
        to,
    ]);
    // console.log("signupRequest_logs Data: ", data?.data);

    return (
        <div className="app-content content dashboard">
            <div className="content-wrapper">
                <div className="content-body">
                    {/* Basic form layout section start */}
                    <section id="configuration">
                        <div className="row">
                            <div className="col-12">
                                <div className="user-details-wrapper">
                                    <div className="row mb-4">
                                        <div className="col-12">
                                            <div className="back-title">
                                                <BackButton />
                                                <h1 className="pageTitle m-0">
                                                    Signup Request
                                                </h1>
                                            </div>
                                        </div>
                                    </div>
                                    <Table
                                        key={"mover-management-signup-requests-table"}
                                        tableTitles={[
                                            "S.No.",
                                            "Full Name",
                                            "Email Address",
                                            "Date",
                                            "Phone",
                                            "Status",
                                            "Action",
                                        ]}
                                        dateFilter
                                        showEntries
                                        // sortBy
                                        isLoading={isLoading}
                                        isFetching={isFetching}
                                        data={data?.data?.data?.docs}
                                        totalPages={Math.ceil(data?.data?.data?.totalPages || 0)}
                                        totalDocs={data?.data?.data?.totalDocs}
                                        page={page}

                                        setPage={setPage}
                                        setSearchString={setSearchString}
                                        status={status}
                                        setStatus={setStatus}
                                        perPage={perPage}
                                        setPerPage={setPerPage}
                                        from={from}
                                        setFrom={setFrom}
                                        to={to}
                                        setTo={setTo}
                                    // status_options={[
                                    //   {
                                    //     label: "Pending",
                                    //     value: "pending",
                                    //   },
                                    //   {
                                    //     label: "Approved",
                                    //     value: "approved",
                                    //   },
                                    //   {
                                    //     label: "Rejected",
                                    //     value: "rejected",
                                    //   },
                                    // ]}
                                    >

                                        {data?.data?.data?.docs?.map((item, index) => (
                                                <tr key={item?._id || index}>
                                                    <td>{getSerialNumber(data?.data?.data, index)}</td>
                                                    <td>{item?.user?.firstName}</td>
                                                    <td>{item?.user?.email}</td>
                                                    <td>
                                                        {item?.createdAt &&
                                                            format_date(item?.createdAt, "MM/DD/YYYY")}
                                                    </td>
                                                    <td>
                                                        {item?.user?.phoneVerified ? (
                                                            <span className="table-status approved">Verified</span>
                                                        ) : (
                                                            <span className="table-status rejected">Unverified</span>
                                                        )}
                                                    </td>
                                                    <td className="text-capitalize">
                                                        <span className={`table-status ${item?.status?.toLowerCase()}`}>
                                                            {item?.reverification && item?.status === "pending"
                                                                ? "Re-verification"
                                                                : item?.status}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <StatusHandler
                                                            key={`${item?._id}-status`}
                                                            view
                                                            item={item}
                                                            redirectUrl={`/mover-management/signup-requests/${item?._id}`}
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                    </Table>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
}
